import { useState } from "react";
import { Layout, Select } from "antd";
import SideNavBar from "../../Components/SideBar/Sidebar";
import "../Adjustments/Adjustments.css";
import Navbar from "../../Components/Support/Header";
import SNdataUpdate from "../../Components/SNdataUpdate/SNUpdate";
import MyTable from "../../Components/TableAdjustments/AdjTable";
import { Option } from "antd/es/mentions";
import { ErrorMessage, StringValidations } from "../../Utils/Utils";
import { FetchAllAdjustments } from "../../Repository/AdjustmentsRepository";
const { Header, Content } = Layout;

const Adjustments = () => {
  const [dataSource, setDataSource] = useState([]);
  const [PayFrequency, setPayFrequency] = useState("");

  const fetchData = async () => {
    if (StringValidations(PayFrequency)) {

      const Response = await FetchAllAdjustments(PayFrequency);
      if (Response != null) {
        setDataSource(Response);
      }
    }
    else {
      setDataSource([]);
    }
  };

  //Frequency DropDown
  const frequencyItems = [
    {
      label: "Weekly",
      key: "W",
    },
    {
      label: "Bi-Weekly",
      key: "B",
    },
  ];

  const HandlePayFrequencyValidation = () => {
    console.log("Frequency Validation");
    if (!StringValidations(PayFrequency)) {
      ErrorMessage("Please select Adjustment Frequency to continue...")
    }
  }

  return (
    <Layout style={{ height: "100vh", overflow: "hidden" }}>
      <SideNavBar />
      <Layout style={{ background: "white", overflow: "hidden" }}>
        <Header className="adj-header">
          <Navbar />
        </Header>

        <div className="pay-frequency-container">
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div >
              <h1 className="adjustment-title">Adjustments</h1>
            </div>
            <Select
              onSelect={(value) => setPayFrequency(value)}
              allowClear
              onClear={() => setPayFrequency("")}
              // onChange={(frequency) => GetFrequencyValue(frequency)}
              style={{ width: "200px" }}
              size="large"
              placeholder="Select Pay Frequency"
            >
              {frequencyItems.map((item, index) => (
                <Select.Option key={index} value={item.key}>
                  {item.label}
                </Select.Option>
              ))}
            </Select>
            {
            StringValidations(PayFrequency) ? <></> : <p style={{ color: "orange", marginLeft:"5px" }}>Please select Pay Frequency to continue ...</p>
          }
          </div>
          
        </div>
        <div
          className={StringValidations(PayFrequency) ? "" : "frequency-blur"}
          style={{ overflowY: "scroll", overflowX: "hidden", height: "100vh" }}
        >

          <SNdataUpdate
            PayFrequency={PayFrequency}
            setPayFrequency={setPayFrequency}
            fetchData={fetchData}
            dataSource={dataSource}
            setDataSource={setDataSource}
          />
          <MyTable
            PayFrequency={PayFrequency}
            fetchData={fetchData}
            dataSource={dataSource}
            setDataSource={setDataSource}
          />
        </div>
      </Layout>
    </Layout>
  );
};

export default Adjustments;
